import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const NoFound: FC = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <Main className="sweep-empty">
            <Img src="/images/nodata.png" />
            <Title>{t('base.no more')}</Title>
        </Main>
    );
};
const Main = styled.div`
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding: 0.33rem 0;
`;
const Img = styled.img`
    width: 2.2rem;
`;
const Title = styled.div`
    height: 0.17rem;
    font-size: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 0.17rem;
    margin-top: 0.12rem;
`;

export default NoFound;
